import React from 'react';
import styled from 'styled-components';
import linkedinIcon from '../assets/Footer/linkedin.svg';
import twitterIcon from '../assets/Footer/twitter.svg';
import fbIcon from '../assets/Footer/fb.svg';
import { SectionParent } from './StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import EsperLogoBlue from '../assets/v2/esper.svg';
import { Link } from 'gatsby';
const FooterSection = styled.footer`
  grid-template-columns: repeat(12, 1fr);
  position: relative;
  background-color: #fff;
`;
const FooterSectionTop = styled(SectionParent)`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: repeat(12, 1fr);
  @media (max-width: 960px) {
    grid-template-columns: repeat(6, 1fr);
  }
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
`;

const FooterSectionColumn2 = styled.div`
  grid-column: span 6;
`;

const FooterSectionTitle = styled.div`
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  color: #2f2f2f;
  margin-bottom: 1rem;
  letter-spacing: normal;
`;

const TwoColumn = styled.div`
  padding-top: 1rem;
  grid-column: span 2;
  @media (max-width: 960px) {
    padding-top: 0rem;
    padding-bottom: 1rem;
  }

  @media (max-width: 520px) {
    grid-column: span 3;
    justify-self: left;
    text-align: left;
  }
`;

const CopyRightText = styled.span`
  font-size: 18px;
  text-align: center;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f2f2f;
  align-self: center;
  justify-self: left;
`;

const FooterLogos = styled(LazyLoadImage)`
  margin-left: 0rem;
  cursor: pointer;
  opacity: 0.7;
  transition: 300ms ease-in;
  @media (min-width: 960px) {
    float: left;
  }
  :hover {
    opacity: 1;
  }
`;

const FooterSocialIconsGroup = styled.div`
  display: grid;
  grid-template-columns: 50px 50px 50px;
  justify-content: right;
`;

const FooterTopBanner = styled.div`
  width: 100%;
  height: 6px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;
const BannerLeft = styled.div`
  background: #96d3f7;
`;
const BannerRight = styled.div`
  background: #715cbd;
`;

const FooterSectionBottom = styled(SectionParent)`
  padding-top: 2rem !important;
  margin-bottom: 2rem;
  display: grid;
  border-top: solid 1px rgba(116, 124, 157, 0.11);
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 520px) {
    margin-bottom: 1rem;
    justify-items: center;
    grid-gap: 1rem;
    grid-template-columns: repeat(1, 1fr);
  }
`;

const Description = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  margin-top: 22px;
  font-size: 15px;
  padding-right: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.73;
  letter-spacing: normal;
  color: #54586b;
`;

const Address = styled(Description)`
  color: #54586b;
`;

const ColumnItem = styled(Link)`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.4;
  letter-spacing: normal;
  color: #54586b;
`;
const ColumnItemA = styled.a`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.4;
  letter-spacing: normal;
  color: #54586b;
`;
export default (props: any) => (
  <FooterSection id="footer-main">
    <FooterTopBanner>
      <BannerLeft />
      <BannerRight />
    </FooterTopBanner>
    <FooterSectionTop>
      <FooterSectionColumn2>
        <LazyLoadImage
          src={EsperLogoBlue}
          alt="Esper logo"
          style={{
            height: '44px',
            width: '180px',
            marginLeft: '-26px',
            transition: '1s ease-in-out',
          }}
          id="footer-main-esper-logo"
        />
        <Description id="footer-main-description">
          {props.messages?.WebsiteGeneralFooterText ??
            'Esper empowers Engineers, Developers, and Operations teams with tools crafted for company owned Android devices. Our full stack platform covers building, deploying, managing, and maintaining to move beyond MDM and to Android DevOps.'}
        </Description>
        <Address>
          Esper
          <br />
          3600 136th Pl SE # 220,
          <br />
          Bellevue, WA 98006
          {/* <br />
          partner@esper.in
          <br />
          +1 916-759-8231 */}
        </Address>
      </FooterSectionColumn2>
      <TwoColumn>
        <FooterSectionTitle>
          {' '}
          {props.messages?.WebsiteGeneralFooterExplore ?? 'Explore'}
        </FooterSectionTitle>
        {(!props.messages || props.messages?.locale === 'en') && (
          <>
            <div id="footer-main-platform-div">
              <ColumnItem to="/manage" id="footer-main-platform">
                Platform
              </ColumnItem>
            </div>
            <div id="footer-main-app-management-div">
              <ColumnItem to="/developer" id="footer-main-app-management">
                Developer Tools
              </ColumnItem>
            </div>
            <div id="footer-main-retail-device-management-div">
              <ColumnItem
                to="/retail-device-management"
                id="footer-main-retail-device-management"
              >
                Retail Solution
              </ColumnItem>
            </div>
            <div id="footer-main-kiosk-solution-div">
              <ColumnItem
                to="/kiosk-device-management"
                id="footer-main-kiosk-solution"
              >
                Kiosk Solution
              </ColumnItem>
            </div>
          </>
        )}
        <div id="footer-main-blog-div">
          <ColumnItemA href="https://blog.esper.io" id="footer-main-blog">
            {props.messages?.WebsiteGeneralFooterBlog ?? 'Blog'}
          </ColumnItemA>
        </div>

        {(!props.messages || props.messages?.locale === 'en') && (
          <>
            <div id="footer-main-partner-div">
              <ColumnItem to="/partner" id="footer-main-partner">
                Partner
              </ColumnItem>
            </div>
            <div id="footer-main-media-coverage-div">
              <ColumnItem to="/media-coverage" id="footer-main-media-coverage">
                Media Coverage
              </ColumnItem>
            </div>
          </>
        )}
        <div id="footer-main-documentation-div">
          <ColumnItemA
            href="https://docs.esper.io"
            id="footer-main-documentation"
          >
            {props.messages?.WebsiteGeneralFooterDocs ?? 'Docs'}
          </ColumnItemA>
        </div>
        {(!props.messages || props.messages?.locale === 'en') && (
          <div id="footer-main-careers-div">
            <ColumnItem to="/careers" id="footer-main-careers">
              Careers
            </ColumnItem>
          </div>
        )}
      </TwoColumn>
      {(!props.messages || props.messages?.locale === 'en') && (
        <TwoColumn>
          <FooterSectionTitle> Products </FooterSectionTitle>
          <div id="footer-main-commercial-android-div">
            <ColumnItem to="/hardware" id="footer-main-commercial-android">
              Commercial Android
            </ColumnItem>
          </div>
          <div id="footer-main-custom-device-div">
            <ColumnItem to="/custom-device" id="footer-main-custom-device">
              Custom Device
            </ColumnItem>
          </div>
          <div id="footer-main-esper-test-lab-div">
            <ColumnItem to="/test-lab" id="footer-main-esper-test-lab">
              Esper Test Lab
            </ColumnItem>
          </div>
          <div id="footer-main-esper-androidx86-div">
            <ColumnItem to="/android-x86" id="footer-main-esper-androidx86">
              Esper Androidx86{' '}
            </ColumnItem>
          </div>
          <div id="footer-main-esper-virtual-devices-div">
            <ColumnItem
              to="/android-virtual-device"
              id="footer-main-esper-virtual-devices"
            >
              Esper Virtual Devices
            </ColumnItem>
          </div>
          <div id="footer-main-esper-devkit-div">
            <ColumnItem to="/hardware" id="footer-main-esper-devkit">
              Esper Developer Kits
            </ColumnItem>
          </div>
        </TwoColumn>
      )}
      <TwoColumn>
        <FooterSectionTitle>
          {' '}
          {props.messages?.WebsiteGeneralFooterContact ?? 'Contact'}{' '}
        </FooterSectionTitle>
        <div id="footer-main-contact-us-div">
          <ColumnItem
            to={
              props.currentLanguage && props.currentLanguage !== 'en'
                ? `/${props.currentLanguage}/contact-us`
                : `/contact-us`
            }
            id="footer-main-contact-us"
          >
            {props.messages?.WebsiteGeneralFooterGetInTouch ?? 'Get in Touch'}
          </ColumnItem>
        </div>
        <div id="footer-main-pricing-div">
          <ColumnItem
            to={
              props.currentLanguage && props.currentLanguage !== 'en'
                ? `/${props.currentLanguage}/pricing`
                : `/pricing`
            }
            // to="/pricing"
            id="footer-main-pricing"
          >
            {props.messages?.WebsiteGeneralMenuPricing ?? 'Pricing'}
          </ColumnItem>
        </div>
        <div id="footer-main-free-demo-div">
          <ColumnItem
            to={
              props.currentLanguage && props.currentLanguage !== 'en'
                ? `/${props.currentLanguage}/book-demo`
                : `/book-demo`
            }
            // to="/book-demo"
            id="footer-main-free-demo"
          >
            {props.messages?.WebsiteGeneralFooterBookAFreeDemo ??
              'Book a Free Demo'}
          </ColumnItem>
        </div>
        {props.currentLanguage !== 'es' && (
          <div id="footer-main-about-us-div">
            <ColumnItem
              // to="/aboutus"
              to={
                props.currentLanguage && props.currentLanguage !== 'en'
                  ? `/${props.currentLanguage}/aboutus`
                  : `/aboutus`
              }
              id="footer-main-about-us"
            >
              {props.messages?.WebsiteGeneralMenuAboutUs ?? 'About Us'}
            </ColumnItem>
          </div>
        )}
        <div id="footer-main-faq-div">
          <ColumnItem
            //  to="/faq"
            to={
              props.currentLanguage && props.currentLanguage !== 'en'
                ? `/${props.currentLanguage}/faq`
                : `/faq`
            }
            id="footer-main-faq"
          >
            {props.messages?.WebsiteGeneralFooterFAQ ?? 'FAQ'}
          </ColumnItem>
        </div>
        <div id="footer-main-terms-of-service-div">
          <ColumnItem
            // to="/terms-of-service"
            to={
              props.currentLanguage && props.currentLanguage !== 'en'
                ? `/${props.currentLanguage}/terms-of-service`
                : `/terms-of-service`
            }
            id="footer-main-terms-of-service"
          >
            {props.messages?.WebsiteGeneralMenuTermsOfService ??
              'Terms of Service'}
          </ColumnItem>
        </div>
        <div id="footer-main-privacy-policy-div">
          <ColumnItem
            //  to="/privacy-policy"
            to={
              props.currentLanguage && props.currentLanguage !== 'en'
                ? `/${props.currentLanguage}/privacy-policy`
                : `/privacy-policy`
            }
            id="footer-main-privacy-policy"
          >
            {props.messages?.WebsiteGeneralFooterPrivacyPolicy ??
              'Privacy Policy'}
          </ColumnItem>
        </div>
        <div id="footer-main-sitemap-div">
          <ColumnItemA
            href={
              props.currentLanguage !== 'en'
                ? `https://esper.io/${props.currentLanguage}/sitemap.xml`
                : `https://esper.io/sitemap.xml`
            }
            id="footer-main-sitemap"
          >
            {props.messages?.WebsiteGeneralFooterSitemap ?? 'Sitemap'}
          </ColumnItemA>
        </div>
      </TwoColumn>
    </FooterSectionTop>
    <FooterSectionBottom>
      {!props.messages ? (
        <CopyRightText>
          © {'Copyright'} {new Date().getFullYear()}{' '}
          {'Esper - All Rights Reserved'}
        </CopyRightText>
      ) : (
        <CopyRightText>
          © {props.messages?.WebsiteGeneralCopyright1}{' '}
          {new Date().getFullYear()} {props.messages?.WebsiteGeneralCopyright2}
        </CopyRightText>
      )}

      <FooterSocialIconsGroup>
        <a
          href="https://www.linkedin.com/company/esperdev"
          rel="noopener noreferrer"
          target="_blank"
          aria-label="linkedin"
          id="footer-main-linkedin"
        >
          <FooterLogos
            alt="linkedin"
            src={linkedinIcon}
            id="footer-main-linkedin-logo"
          />
        </a>
        <a
          href="https://twitter.com/@esperdev"
          rel="noopener noreferrer"
          target="__blank"
          aria-label="Twitter"
          id="footer-main-twitter"
        >
          <FooterLogos
            alt="twitter"
            src={twitterIcon}
            id="footer-main-twitter-logo"
          />
        </a>
        <a
          href="https://www.facebook.com/esperdev/"
          rel="noopener noreferrer"
          target="_blank"
          aria-label="facebook"
          id="footer-main-facebook"
        >
          <FooterLogos
            alt="facebook"
            src={fbIcon}
            id="footer-main-facebook-logo"
          />
        </a>
      </FooterSocialIconsGroup>
    </FooterSectionBottom>
  </FooterSection>
);
